var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 694 471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "logo-svg-fill-light",
    fill: "#1C1A1A",
    d: "M471.6,223h122c4.6,0,7.4-2.8,7.4-7.4v-26.5c0-4.6-2.8-7.4-7.4-7.4h-84.1V30.2c0-4.6-2.8-7.4-7.4-7.4h-30.5     c-4.6,0-7.4,2.8-7.4,7.4v185.4C464.2,220.2,467,223,471.6,223z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "logo-svg-fill-light",
    fill: "#1C1A1A",
    d: "M549.6,449h122.6c4.6,0,7.4-2.8,7.4-7.4v-26.5c0-4.6-2.8-7.4-7.4-7.4h-84.7v-38.2h78.2c4.6,0,7.4-2.8,7.4-7.4     v-26.5c0-4.6-2.8-7.4-7.4-7.4h-78.2v-38.2h84.7c4.6,0,7.4-2.8,7.4-7.4v-26.5c0-4.6-2.8-7.4-7.4-7.4H549.6c-4.6,0-7.4,2.8-7.4,7.4     v185.4C542.2,446.2,545,449,549.6,449z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "logo-svg-fill-color",
    fill: "#FFF",
    fillOpacity: 0.7,
    d: "M12,123c0,55.2,44.8,100,100,100c1.6,0,3.2,0,4.8-0.1c0.4,0.1,0.8,0.1,1.2,0.1h88c3.3,0,6-2.7,6-6v-88     c0-0.4,0-0.8-0.1-1.2c0.1-1.6,0.1-3.2,0.1-4.8c0-55.2-44.8-100-100-100C56.8,23,12,67.8,12,123z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "logo-svg-fill-color",
    fill: "#FFF",
    fillOpacity: 0.4,
    d: "M112,449c55.2,0,100-44.8,100-100c0-1.6,0-3.2-0.1-4.8c0.1-0.4,0.1-0.8,0.1-1.2v-88c0-3.3-2.7-6-6-6h-88     c-0.4,0-0.8,0-1.2,0.1c-1.6-0.1-3.2-0.1-4.8-0.1c-55.2,0-100,44.8-100,100S56.8,449,112,449z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "logo-svg-fill-color",
    fill: "#FFF",
    d: "M338,23c-55.2,0-100,44.8-100,100c0,1.6,0,3.2,0.1,4.8c-0.1,0.4-0.1,0.8-0.1,1.2v88c0,3.3,2.7,6,6,6h88     c0.4,0,0.8,0,1.2-0.1c1.6,0.1,3.2,0.1,4.8,0.1c55.2,0,100-44.8,100-100S393.2,23,338,23z M338,178c-30.4,0-55-24.6-55-55     s24.6-55,55-55s55,24.6,55,55S368.4,178,338,178z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "logo-svg-fill-light",
    fill: "#1C1A1A",
    d: "M309.3,449h25.9c4.3,0,7.4-2.2,8.6-6.2l33.3-100.4l33.3,100.4c1.2,4,4.3,6.2,8.6,6.2h25.9     c4.3,0,7.4-2.2,8.6-6.2l61.9-185.7c1.5-4.9-0.9-8.3-6.2-8.3h-32.6c-4.3,0-7.4,2.2-8.6,6.2l-35.1,106l-35.7-106     c-1.2-4-4.3-6.2-8.6-6.2h-20.3c-4.3,0-7.1,2.2-8.3,6.2l-37,111.8l-37-111.8c-1.2-4-4-6.2-8.3-6.2h-32.6c-5.2,0-7.7,3.4-6.2,8.3     l61.9,185.7C301.9,446.8,305,449,309.3,449z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.acacedcfcb00eb0e2a4e9d6c1da20e36.svg";
export { ForwardRef as ReactComponent };